import React from 'react';
import Link from 'react-router';
import Moment from 'react-moment';
import { browserHistory } from 'react-router';

import { Meteor } from 'meteor/meteor';

import {
  Button
} from '@sketchpixy/rubix';

export default class PriceListComponent extends React.Component {

  	render() {
  	  	return (
  	  	  	<tr>
              <td>{this.props.price.title}</td>
              <td>{this.props.price.price}€</td>
              <td><Moment format="DD/MM/YYYY">{this.props.price.createdAt}</Moment></td>
              <td><Moment format="DD/MM/YYYY">{this.props.price.editedAt}</Moment></td>
              <td>
                  <Button bsStyle="warning" onClick={this.goToEditView.bind(this)}>Modifier</Button>&nbsp;&nbsp;
                  <Button bsStyle="danger" onClick={this.deleteThisPrice.bind(this)}>Supprimer</Button>
              </td>
            </tr>
  	  	);
  	}

    deleteThisPrice() {
      Meteor.call('prices.remove', this.props.price._id);
    }

    goToEditView() {
     this.context.router.push('/prices/' + this.props.price._id);
    }

}

PriceListComponent.propTypes = {
  // This component gets the task to display through a React prop.
  // We can use propTypes to indicate it is required
  price: React.PropTypes.object.isRequired,
};

PriceListComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/prices/component-prices-list.js
 **/